export type CacheState = {
  lastFetched: number | null;
  inFlight: Map<string, Promise<unknown>>;
};

export function isCacheFresh(lastFetched: number | null, ttlMs: number) {
  return lastFetched !== null && Date.now() - lastFetched < ttlMs;
}

export async function withInFlight<T>(
  state: CacheState,
  key: string,
  task: () => Promise<T>,
): Promise<T> {
  const existing = state.inFlight.get(key);
  if (existing) return existing as Promise<T>;
  const promise = task();
  state.inFlight.set(key, promise as Promise<unknown>);
  try {
    return await promise;
  } finally {
    state.inFlight.delete(key);
  }
}

export function createCacheState(): CacheState {
  return {
    lastFetched: null,
    inFlight: new Map<string, Promise<unknown>>(),
  };
}

export const DEFAULT_TTL_MS = 3 * 60 * 1000;

/**
 * Короткий TTL для «витрин» (дашборд, сущности сегмента): освежает данные
 * при заходе, но не перекачивает весь список на каждый визит и не упирается
 * в бэкендовый лимит 1 запрос/роут/сек при быстрой навигации.
 */
export const FRESH_TTL_MS = 30 * 1000;
